import ReactDom from 'react-dom';

const LoadingPortal = ({children}) => {
  const el = document.getElementById('loading-root');

  return ReactDom.createPortal(children, el);
};

const LoadingPage = () => {
  return (
    <h3 id='loading-icon'></h3>
  );
}

const LoadingIndicator = () => {
  return (<ul className="bpl-loading-indicator">
  <li>L</li>
  <li>o</li>
  <li>a</li>
  <li>d</li>
  <li>i</li>
  <li>n</li>
  <li>g</li>
  <li>.</li>
  <li>.</li>
  <li>.</li>
</ul>)
}
const LoadingIndicatorBox = (white = false) => {
    return (<div
      style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1000,
          backgroundColor: white ? "transparent" : "#0008",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: white ? "#999" : "#FFF",
          fontWeight: "bold",
      }}
  >
      <LoadingIndicator />
  </div>)
}


export default LoadingPortal;
export {LoadingPage, LoadingIndicator, LoadingIndicatorBox}
